<div class="modal-header">
  <h3 class="modal-title fkm-modal-title" id="modal-title">{{data.namn}}</h3>
  <button type="button" id="btnKundDetailClose" class="btn-close" (click)="dismiss()"></button>
</div>
@if (initialized) {
  <div class="modal-body">
    <div class="row">
      <rask-textmultiline aid="huvudkod" class="col-3" [label]="texts.huvudkod" [value]="kund.huvudkod"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="internnummer" class="col-3" [label]="texts.internnummer" [value]="kund.internnummer"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="telefon" class="col-3" [label]="texts.telefon" [value]="kund.telefon"
      [tightLabel]="true"></rask-textmultiline>
      <rask-checkbox
        aid="doldkund"
        class="col-3"
        [text]="texts.dolj"
        label="Dölj i kundorder"
        [(ngModel)]="data.doljForKundorder"
        (ngModelChange)="onDoldChange($event)"
        [disabled]="disableDoljkund()"
      infoText="Kund döljs i kundorder. Kunden kan endast döljas om den saknar kopplade kunder samt att kunden inte är kopplad till någon kundorder."></rask-checkbox>
    </div>
    @if (data.doljForKundorder) {
      <div class="row">
        <rask-selector
          aid="foralderKund"
          [label]="texts.kopplaTill"
          [values]="kund.valbaraForaldraKunder"
          [viewFormatter]="kundFormatter"
          [formatter]="idFormatter"
          [(ngModel)]="data.parentKundId"
        (ngModelChange)="onBefraktareChange()"></rask-selector>
      </div>
    }
    @if (!data.doljForKundorder) {
      <div class="row">
        <rask-textmultiline aid="koppladekunderlista" class="col-12" [label]="texts.koppladeKunder"
        [value]="koppladeKunder" [tightLabel]="true"></rask-textmultiline>
      </div>
    }
    <div class="row">
      <rask-textmultiline aid="uppdaterad" class="col-4" [label]="texts.uppdaterad" [value]="kund.uppdaterad"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="limeId" class="col-4" [label]="texts.limeId" [value]="kund.limeId"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="statusILime" class="col-4" [label]="texts.statusILime" [value]="kund.statusILime"
      [tightLabel]="true"></rask-textmultiline>
    </div>
    <div class="row">
      <rask-textmultiline aid="orgNummer" class="col-4" [label]="texts.organisationsnummer" [value]="kund.orgNummer"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="avtalsansvarig" class="col-4" [label]="texts.avtalsansvarig"
      [value]="kund.avtalsansvarig" [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="avdelning" class="col-4" [label]="texts.avdelning" [value]="kund.avdelning"
      [tightLabel]="true"></rask-textmultiline>
    </div>
    <div class="row">
      <rask-textmultiline aid="besoksadress" class="col-4" [label]="texts.besoksadress" [values]="kund.besoksadress"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="postadress" class="col-4" [label]="texts.postadress" [values]="kund.postadress"
      [tightLabel]="true"></rask-textmultiline>
      <rask-textmultiline aid="landOchLandskod" class="col-4 land-text" [label]="texts.landOchLandskod"
      [value]="kund.landOchLandskod" [tightLabel]="true"></rask-textmultiline>
    </div>
    <div class="row">
      <rask-textarea aid="beskrivning" class="col-12" [label]="texts.beskrivning" [(ngModel)]="data.beskrivning"
        (ngModelChange)="onChange()" [disabled]="!canEdit">
      </rask-textarea>
    </div>
    <div class="row">
      <div class="col-4">
        <rask-checkbox aid="befraktare" text="Befraktare" [(ngModel)]="data.befraktare"
        (ngModelChange)="onBefraktareChange()" [disabled]="!canEdit"></rask-checkbox>
      </div>
      @if (data.befraktare) {
        <div class="col-4">
          <div class="colorpicker-container">
            <fieldset class="form-group inline mb-3">
              <label>FÄRG</label>
              <div class="picker-input-group">
                <div (click)="openColorPicker()" class="colorpicker"
                  [ngStyle]="{'background-color' : data.color}">
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      }
    </div>
    @if (data.befraktare) {
      <div class="row">
        <rask-label size="12">Transporttilldela befraktare med automatik</rask-label>
      </div>
      @for (styrningRow of data.befraktarstyrningar; track styrningRow; let i = $index) {
        <ng-container class="row">
          <div [formGroup]="form">
            <rask-kund-details-modal-befraktarstyrning
              [styrningRow]="styrningRow"
              [rootForm]="form"
              [data]="data"
              (deleteRow)="onDeleteRow($event)"
            [index]="i"></rask-kund-details-modal-befraktarstyrning>
          </div>
        </ng-container>
      }
      <div class="row">
        <rask-action-button col="12" aid="laggtillbefraktarstyrning" (click)="addBefraktarstyrning()"
        icon="fas fa-plus">Lägg till</rask-action-button>
      </div>
    }
  </div>
}

<div class="modal-footer">
  <rask-save-button aid="buttonDetailRadSave" (click)="save()" [disabled]="!canSave()">
  </rask-save-button>
</div>